/**
 * Translation API client (P2-S8 i18n).
 */
import { api } from "./client";

export interface TranslationOut {
  id: string;
  locale: string;
  namespace: string;
  key: string;
  value: string;
  description: string | null;
  updated_by: string | null;
  updated_at: string;
}

export interface UpsertBody {
  locale: string;
  namespace: string;
  key: string;
  value: string;
  description?: string | null;
}

export interface BulkUpsertBody {
  items: UpsertBody[];
}

export const translationsApi = {
  list: (params: {
    locale?: string;
    namespace?: string;
    key_prefix?: string;
    limit?: number;
  } = {}) =>
    api.get<TranslationOut[]>("/api/v1/admin/translations", {
      query: params,
    }),
  listLocales: () =>
    api.get<string[]>("/api/v1/admin/translations/locales"),
  listNamespaces: () =>
    api.get<string[]>("/api/v1/admin/translations/namespaces"),
  upsert: (body: UpsertBody) =>
    api.post<TranslationOut>("/api/v1/admin/translations", body),
  bulkUpsert: (items: UpsertBody[]) =>
    api.post<{ upserted: number }>("/api/v1/admin/translations/bulk", {
      items,
    }),
  remove: (id: string) =>
    api.delete<void>(`/api/v1/admin/translations/${id}`),
  // Public bundle (cần auth)
  getBundle: (locale: string, namespace: string) =>
    api.get<Record<string, string>>(
      `/api/v1/i18n/${encodeURIComponent(locale)}/${encodeURIComponent(namespace)}`,
    ),
};
